import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LocaleContext } from "../routing/LangRouter";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";

const useRevalidate = (isFlightInternational, isHotelInternational, setLoading) => {
    //general variables
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //sessionStorage variables
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation"));
    const isInternational = isFlightInternational && isHotelInternational;

    //Function to clear session storage items related to the international flight
    const clearSessionStorage = () => {
        sessionStorage.removeItem("IntFlightDetails");
        sessionStorage.removeItem("selectedIntFlight");
        sessionStorage.removeItem("intFlightPassengers");
        sessionStorage.removeItem("selectedFlight");
        sessionStorage.removeItem("flightPassengers");

        sessionStorage.removeItem("selectedHotel");
        sessionStorage.removeItem("selectedIntRooms");
        sessionStorage.removeItem("intHotelPassengers");
        sessionStorage.removeItem("checkRateData");
    };

    // Function to revalidate the international flight or hotel
    const revalidateItem = async (endpoint, fareSourceCode, errorRedirect) => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/v2/reserve/${endpoint}/`, {
                fare_source_code: fareSourceCode,
            });

            if (errorRedirect === "hotel") {
                sessionStorage.setItem("checkRateData", JSON.stringify(response.data.data));
            }

            if (response.status === 200) {
                const newPrice = errorRedirect !== "hotel" ? response.data.data.flight_data.fares.total_price : response.data.data.fare.total;
                return newPrice;
            }
        } catch (error) {
            handleRevalidationError(errorRedirect);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const handleRevalidationError = errorRedirect => {
        const errorMessage = errorRedirect !== "hotel" ? t("failTicketMessage") : t("Toast Messages.Invalid Room Selection");
        toast.error(errorMessage, { toastId: "flight-change-toast" });

        navigate(`/${locale}/${errorRedirect}`);

        clearSessionStorage();

        if (!isInternational && (errorRedirect !== "hotel")) {
            sessionStorage.setItem("domesticFlightInformation", JSON.stringify(domesticFlightInformation));
        }
    };

    const revalidateBooking = async (fareSourceCode, errorRedirect) => {
        if (errorRedirect === "hotel") {
            return await revalidateItem(
                isHotelInternational ? "foreign/accommodation/check-rate" : "accommodation/check-rate",
                fareSourceCode,
                errorRedirect,
            );
        } else {
            return await revalidateItem(isFlightInternational ? "foreign/flight/revalidate" : "flight/revalidate", fareSourceCode, errorRedirect);
        }
    };

    return {
        revalidateBooking,
    };
};

export default useRevalidate;
